__turbopack_context__.v({
  "is_active": "wnxuWW_is_active",
  "tab_link": "wnxuWW_tab_link",
});
